import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Link)`
  color: ${(p) => p.theme.palette.primary[500]};
  font-size: ${(p) => p.theme.typography.body3.fontSize};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;
